<template>
  <div class="faq-section" ref="section">
    <div class="vline" ref="vlineLeft"></div>
    <div class="vline" ref="vlineRight"></div>
    <div class="faq-container">
      <div class="faq-left">
        <p class="faq-label">FAQ.</p>
        <h2 class="faq-title">Les questions fréquemment posées.</h2>
      </div>
      <div class="faq-right" ref="faqRight">
        <faq-list
          v-for="(item, i) in faq"
          :key="i"
          :faq-lists="item"
          :index="i + 1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FaqList from "../../helper/add/faq-list.vue"

export default {
  name: "faq-hackathon",
  components: { FaqList },
  data() {
    return {
      faq: [
        {
          question: "Qui peut participer au hackathon ?",
          answer: "Tout développeur, designer ou entrepreneur passionné par Bitcoin et les technologies blockchain peut participer. Aucun niveau d'expérience minimum requis, débutants et experts sont les bienvenus."
        },
        {
          question: "Est-ce que le hackathon est gratuit ?",
          answer: "Oui, la participation au Bitcoin Mastermind Hackathon est entièrement gratuite. Les repas et le matériel sont pris en charge pendant les 3 jours."
        },
        {
          question: "Faut-il avoir une idée de projet avant de s'inscrire ?",
          answer: "Non, vous pouvez venir sans idée. Les équipes sont formées sur place le Jour 1 et les idées émergent lors des sessions de brainstorming collectif."
        },
        {
          question: "Quelles technologies sont utilisées pendant le hackathon ?",
          answer: "Le hackathon se concentre sur l'écosystème Bitcoin : Bitcoin Dev Kit, Lightning Dev Kit, Flash, LNbits, Blink API, Nostr et d'autres outils de l'écosystème Bitcoin et Lightning Network."
        },
        {
          question: "Comment sont formées les équipes ?",
          answer: "Les équipes de 3 à 5 personnes sont constituées le premier jour. Vous pouvez venir avec votre propre équipe ou rejoindre une équipe sur place selon vos compétences et affinités."
        },
        {
          question: "Comment sont jugés les projets ?",
          answer: "Les projets sont évalués sur 4 critères : l'innovation technique, l'impact potentiel pour l'Afrique, la faisabilité de la solution et la qualité de la présentation devant le jury."
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => this.setLines())
    window.addEventListener('resize', this.setLines)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setLines)
  },
  methods: {
    setLines() {
      const section = this.$refs.section
      const right = this.$refs.faqRight
      if (!section || !right) return
      const sRect = section.getBoundingClientRect()
      const rRect = right.getBoundingClientRect()
      this.$refs.vlineLeft.style.left = (rRect.left - sRect.left) + 'px'
      this.$refs.vlineRight.style.left = (rRect.right - sRect.left) + 'px'
    }
  }
}
</script>

<style scoped>
.faq-section {
  background: #ffffff;
  padding: 80px 0 80px 0;
  position: relative;
}
.vline {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 0;
  border-left: 1px dashed #00000080;
  pointer-events: none;
}
.faq-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 64px;
  display: flex;
  gap: 60px;
  align-items: flex-start;
}
.faq-left {
  width: 320px;
  flex-shrink: 0;
  padding-top: 8px;
}
.faq-label {
  font-size: 0.75rem;
  color: #9CA3AF;
  margin: 0 0 16px 0;
  letter-spacing: 0.05em;
}
.faq-title {
  font-size: 2rem;
  font-weight: 800;
  color: #05246A;
  margin: 0;
  line-height: 1.2;
}
.faq-right {
  flex: 1;
}
@media (max-width: 1024px) {
  .faq-section { padding: 64px 0; }
  .vline { display: none; }
  .faq-container { flex-direction: column; padding: 0 32px; gap: 40px; }
  .faq-left { width: 100%; padding-top: 0; }
}
@media (max-width: 768px) {
  .faq-container { padding: 0 24px; gap: 32px; }
  .faq-title { font-size: 1.5rem; }
}
@media (max-width: 480px) {
  .faq-container { padding: 0 16px; gap: 28px; }
  .faq-title { font-size: 1.25rem; }
  .faq-label { font-size: 0.7rem; }
}
</style>
